import platform from '@/shared/utils/platform';

interface IOSKeyboardScrollLock {
  handleInputFocus: () => void;
  handleInputBlur: () => void;
  cleanup: () => void;
}

/**
 * iOS 有输入键盘时禁止页面滚动，解决ios键盘唤起后非必要滚动问题
 * 推荐场景：当前页面高度不大于屏幕高度，无需滚动
 */
export const useIOSKeyboardScrollLock = (): IOSKeyboardScrollLock => {
  /** 非iOS设备不处理，直接返回空函数 */
  if (!platform.isIOS) {
    const noop = (): void => (undefined);

    return {
      handleInputFocus: noop,
      handleInputBlur: noop,
      cleanup: noop,
    };
  }

  const currentPageHash = window.location.hash;

  /** 阻止触摸移动事件-禁止页面滚动的影响面控制：仅在注册的PATH路径页面有效 */
  const preventScrollOnTouchMove = (e: TouchEvent): void => {
    if (window.location.hash !== currentPageHash) {
      return;
    }

    e.preventDefault();
  };

  /** 输入框聚焦时禁止页面滚动 */
  const handleInputFocus = (): void => {
    document.body.addEventListener('touchmove', preventScrollOnTouchMove, {
      passive: false,
    });
  };

  /** 输入框失焦时恢复页面滚动 */
  const handleInputBlur = (): void => {
    document.body.removeEventListener('touchmove', preventScrollOnTouchMove);
  };

  /** 清理函数 */
  const cleanup = (): void => {
    document.body.removeEventListener('touchmove', preventScrollOnTouchMove);
  };

  return {
    handleInputFocus,
    handleInputBlur,
    cleanup,
  };
};
